import { Helmet } from "react-helmet-async";
import "./Template.css";
import bearbitzlogo from "../../assets/images/Bearbitz logo.png";
import { Row, Col } from "antd";
import {
  FaPhone,
  FaEnvelope,
  FaWhatsapp,
  FaFacebook,
  FaUserLock,
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";

const ProductTemplate = ({
  productTitle,
  productImage,
  description,
  tableData,
  BiscuitLogo,
  textColor,
  sectionBgColor,
  productBgcolor,
  footerBgcolor,
}) => {
  const navigate = useNavigate();

  const handleClick = (e) => {
    e.preventDefault();
    if (window.history.length > 2) {
      navigate(-1);
    } else {
      navigate("/");
    }
  };

  return (
    <div className="product-container">
      <a href="#" onClick={handleClick} className="logo-link">
        <img src={bearbitzlogo} alt="Bear Bitz Logo" className="product-logo" />
      </a>

      <div
        className="template-product-card"
        style={{ background: sectionBgColor }}
      >
        <Row className="biscuit-description">
          <div className="product-content">
            <Col>
              <h2 className="product-title" style={{ color: textColor }}>
                {productTitle}
              </h2>
              <div className="template-product-image">
                <img
                  src={productImage}
                  alt={productTitle}
                  style={{ background: productBgcolor }}
                />
              </div>
            </Col>
          </div>
        </Row>
        <Row>
          <p className="product-description" style={{ color: textColor }}>
            <p>Sizes in Grams</p>
            <p className="product-size" style={{ color: textColor }}>
              {tableData.map((row) => (
                <span>{row.grams}g,&nbsp;</span>
              ))}
            </p>
            {description}
          </p>
        </Row>
      </div>

      <div className="curve-bg-container">
        <svg
          viewBox="0 0 1440 200"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
          className="curve-svg"
        >
          <path
            d="M0,200 C400,0 1040,0 1440,200 L1440,200 L0,200 Z"
            fill={footerBgcolor}
          />
        </svg>
        <svg
          viewBox="0 0 1440 200"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="none"
          className="curve-svg-mobile"
        >
          <rect width="1440" height="200" fill={footerBgcolor} />
        </svg>
        <div className="contact-strip">
          <div className="curve-bg">
            <img src={BiscuitLogo} alt={productTitle} className="biscuit-img" />

            <div className="contact-details">
              <div className="contact-item">
                <FaPhone className="icon" style={{ transform: "scaleX(-1)" }} />
                <a href="tel:+919500944656" className="icon">
                  +91 9500944656
                </a>
              </div>
              {/* <div className="contact-item">
                <FaWhatsapp className="icon" />
                <a
                  href="https://wa.me/918248588257"
                  target="_blank"
                  className="icon"
                >
                  +91 82485 88257
                </a>
              </div> */}
              <div className="contact-item">
                <FaFacebook className="icon" />
                <a
                  href="https://www.facebook.com/profile.php?id=61579309993904"
                  target="_blank"
                  className="icon"
                >
                  Bearbitz
                </a>
              </div>
              <div className="contact-item">
                <FaUserLock className="icon" />
                <a href="/privacy-policy" target="_blank" className="icon">
                  Privacy Policy
                </a>
              </div>

              <div className="contact-item email">
                <FaEnvelope className="icon" />
                sales@www.bearbitz.in
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductTemplate;
